import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLeftX"><Path fillRule="evenodd" clipRule="evenodd" d="M7.48537 4L1.77109 12L7.48537 20H22V4H7.48537ZM11.2483 8.58579L13.25 10.5875L15.2517 8.58579L16.6659 10L14.6642 12.0017L16.6642 14.0017L15.25 15.4159L13.25 13.4159L11.25 15.4159L9.83579 14.0017L11.8358 12.0017L9.83412 10L11.2483 8.58579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftX;
